
import './App.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './components/globalComponents/login/styles/resetPassword.scss';
import './styles/text.scss'


import { Route, Routes, useLocation, Navigate } from 'react-router-dom';
import HomePage from './pages/homePage/homePage';
import { ChatProvider } from './context/chatContext';

import { AuthProvider } from './context/authProviderContext';
import PrivateRoute from './routes/PrivateRoute';

import UserPanel from './components/userComponents/userPanel/UserPanel';
import { NewsProvider } from './context/newsContext';
import { LicensesProvider } from './context/licensesContext';
import { ProjectsProvider } from './context/projectsContext';
import { useEffect, useState } from 'react';
import AuthModal from './components/globalComponents/login/authModal';

import AboutUsPage from './pages/aboutUsPage/aboutUsPage';
import ContactPage from './pages/contactPage/contactPage';
import ProductsPage from './pages/productsPage/productsPage';
import ProductsInfoPage from './pages/productsPage/productsinfoPage/productsinfoPage';
import ServicesInfoPage from './pages/productsPage/servicesInfoPage/servicesInfoPage';
import InvestigaciónDesarrolloInnovación from './pages/I+D+iPage/i+d+ipage';
import FormularioEnviado from './pages/contactPage/formularioEnviado/formularioEnviado';
import LegalPage from './pages/legalPage/legalPage';
import CookieBanner from './components/globalComponents/cookieBanner/cookieBanner';


const App = () => {
  const location = useLocation();
  const [modalType, setModalType] = useState(null);
  const [preloadedEmail, setPreloadedEmail] = useState("");

  // ESCUCHAR el evento para abrir el login modal
  useEffect(() => {
    if (location.state?.openLoginModal) {
      const email = localStorage.getItem("reset_email") || "";
      if (email) {
        setPreloadedEmail(email);
        localStorage.removeItem("reset_email");
      }
      setModalType("login");
    }
  }, [location]);

  return (
    <AuthProvider>
      <ChatProvider>
        <div id="n8n-chat" />
        {/*<N8nChat />*/}
        <CookieBanner />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/AboutUsPage" element={<AboutUsPage />} />
          <Route path="/Productos" element={<ProductsPage />} />
          <Route path="/Productos/products" element={<ProductsInfoPage />} />
          <Route path="/Productos/services" element={<ServicesInfoPage />} />
          <Route path="/Contacto" element={<ContactPage />} />
          <Route path="/I+D+i" element={<InvestigaciónDesarrolloInnovación />} />
          <Route path="/mensaje-enviado" element={<FormularioEnviado />} />
          <Route path="/legal" element={<LegalPage />} />
          {/*<Route path="/customize/social" element={<OkapiSocialPage />}/>*/}
          {/*<Route path="/FAQ" element={<FaqPages />} />*/}
          {/*<Route path="/login" element={<LoginButton />} />*/}
          {/*<Route path="/signup" element={<SignUpButton />} />*/}
          {/*<Route path="/reset-password" element={<ResetPasswordForm />} />*/}
          <Route path="/dashboard" element={
            <PrivateRoute>
              <NewsProvider>
                <ProjectsProvider>
                  <LicensesProvider>
                    <UserPanel />
                  </LicensesProvider>
                </ProjectsProvider>
              </NewsProvider>
            </PrivateRoute>
          }
          />
          {/* Catch-all para URLs no encontradas, redirige a inicio */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        {modalType && (
          <AuthModal
            modalType={modalType}
            setModalType={setModalType}
            preloadedEmail={preloadedEmail}
          />
        )}
      </ChatProvider>
    </AuthProvider>
  );
};

export default App;